var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-alert-circle",
    clipPath: "url(#clip0_11280_30412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 11.333C7.63148 11.333 7.33301 11.0345 7.33301 10.6663L7.33301 7.99968C7.33301 7.63149 7.63148 7.33301 7.99967 7.33301C8.36786 7.33301 8.66634 7.63149 8.66634 7.99968L8.66634 10.6663C8.66634 11.0345 8.36786 11.333 7.99967 11.333Z",
    fill: "#37424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 5.99968C8.36786 5.99968 8.66634 5.7012 8.66634 5.33301C8.66634 4.96482 8.36786 4.66634 7.99967 4.66634L7.99301 4.66634C7.62482 4.66634 7.32634 4.96482 7.32634 5.33301C7.32634 5.7012 7.62482 5.99968 7.99301 5.99968L7.99967 5.99968Z",
    fill: "#37424A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 7.99967C15.333 12.0498 12.0498 15.333 7.99967 15.333C3.94959 15.333 0.666341 12.0498 0.666341 7.99968C0.666341 3.94959 3.94959 0.666343 7.99967 0.666342C12.0498 0.666342 15.333 3.94959 15.333 7.99967ZM7.99967 13.9997C11.3134 13.9997 13.9997 11.3134 13.9997 7.99967C13.9997 4.68597 11.3134 1.99968 7.99967 1.99968C4.68597 1.99968 1.99967 4.68597 1.99968 7.99968C1.99968 11.3134 4.68597 13.9997 7.99967 13.9997Z",
    fill: "#37424A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11280_30412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertCircle);
export default __webpack_public_path__ + "static/media/icon_alert_circle.fc6a129b13bf2b89e8115aa083695a64.svg";
export { ForwardRef as ReactComponent };